export class DoctorCountry {
  countryName: string;
  status: boolean;
  id: number;
}
